import { ItemDetail } from "../components/ItemDetail";

export const Detail = () => {
    return (
        <div className="flex justify-center bg-gray-200 mt-14 flex-col gap-10 max-w-xl items-center w-full">
            <ItemDetail />
        </div>
    );
};
